import { render, staticRenderFns } from "./ResultSection.vue?vue&type=template&id=abf605fc"
import script from "./ResultSection.vue?vue&type=script&lang=js"
export * from "./ResultSection.vue?vue&type=script&lang=js"
import style0 from "./ResultSection.vue?vue&type=style&index=0&id=abf605fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports